import MapHomeComponent from '../components/map-home.component'
import StrateActionsComponent from '../components/strate-actions.component'
import StrateMomentsComponent from '../components/strate-moments.component'

export default class HomeService {
    constructor() {
        new MapHomeComponent()

        if (!$('body').hasClass('eco-mode-active')) {
            new StrateActionsComponent()
            new StrateMomentsComponent()
        }
    }
}
